/**
 * B-2 교육과정 대조 요약 문구. 서버가 준 개수·미확인 코드만 쓴다(성취수준 내부 자료는 서버가 응답에 싣지 않는다).
 * 코드가 없던 문서는 null → 아무것도 보여주지 않는다.
 */
export const buildCurriculumGroundingNotice = (meta) => {
  if (!meta || typeof meta !== 'object') return null;
  const matched = Number(meta.matched || 0);
  const unknown = Array.isArray(meta.unknown_codes) ? meta.unknown_codes.filter(Boolean) : [];
  const ambiguous = Array.isArray(meta.ambiguous_codes) ? meta.ambiguous_codes.filter(Boolean) : [];
  if (matched === 0 && unknown.length === 0 && ambiguous.length === 0) return null;
  const parts = [];
  if (matched > 0) parts.push(`성취기준 ${matched}개를 교육부 고시 원문과 대조했어요`);
  const needCheck = [...unknown, ...ambiguous];
  if (needCheck.length > 0) {
    const shown = needCheck.slice(0, 3).join(', ');
    const more = needCheck.length > 3 ? ` 외 ${needCheck.length - 3}개` : '';
    parts.push(`${shown}${more}는 확인이 필요해요`);
  }
  return parts.join(' · ');
};
